<template>
  <div>
    <div class="form-group w-100">
      <label for="line1" class="w-100 text-left">Line 1</label>
      <input v-model="line1" type="text" class="form-control" name="line1" placeholder="Enter address line 1" maxlength="99">
      <validation-message v-if="validator.line1" :message="validator.line1"/>
    </div>
    <div class="form-group w-100">
      <label for="line2" class="w-100 text-left">Line 2 <span class="small text-muted">(optional)</span></label>
      <input v-model="line2" type="text" class="form-control" name="line2" placeholder="Enter address line 2" maxlength="99">
    </div>
    <div class="form-group w-100">
      <label for="line3" class="w-100 text-left">Line 3 <span class="small text-muted">(optional)</span></label>
      <input v-model="line3" type="text" class="form-control" name="line3" placeholder="Enter address line 3" maxlength="99">
    </div>
    <div class="form-group w-100">
      <label for="town" class="w-100 text-left">Town <span class="small text-muted">(optional)</span></label>
      <input v-model="town" type="text" class="form-control" name="town" placeholder="Enter town" maxlength="99">
    </div>
    <div class="form-group w-100">
      <label for="county" class="w-100 text-left">County <span class="small text-muted">(optional)</span></label>
      <input v-model="county" type="text" class="form-control" name="county" placeholder="Enter county" maxlength="99">
    </div>
    <div class="form-group w-100">
      <label for="postCode" class="w-100 text-left">Post/Zip Code</label>
      <input v-model="postCode" type="text" class="form-control" name="postCode" placeholder="Enter post/zip code" maxlength="49">
      <validation-message v-if="validator.postCode" :message="validator.postCode"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'

export default {
  name: 'ClientAddressManualInput',
  props: {
    validator: Object
  },
  computed: {
    ...mapState('BookingUpload', [
      'clientAddress'
    ]),
    line1: {
      get () {
        return this.clientAddress?.line1 || ''
      },
      set (value) {
        this.setClientAddress({
          ...this.clientAddress,
          line1: value
        })
      }
    },
    line2: {
      get () {
        return this.clientAddress?.line2 || ''
      },
      set (value) {
        this.setClientAddress({
          ...this.clientAddress,
          line2: value
        })
      }
    },
    line3: {
      get () {
        return this.clientAddress?.line3 || ''
      },
      set (value) {
        this.setClientAddress({
          ...this.clientAddress,
          line3: value
        })
      }
    },
    town: {
      get () {
        return this.clientAddress?.town || ''
      },
      set (value) {
        this.setClientAddress({
          ...this.clientAddress,
          town: value
        })
      }
    },
    county: {
      get () {
        return this.clientAddress?.county || ''
      },
      set (value) {
        this.setClientAddress({
          ...this.clientAddress,
          county: value
        })
      }
    },
    postCode: {
      get () {
        return this.clientAddress?.postCode || ''
      },
      set (value) {
        this.setClientAddress({
          ...this.clientAddress,
          postCode: value
        })
      }
    }
  },
  methods: {
    ...mapMutations('BookingUpload', [
      'setClientAddress'
    ])
  },
  components: {
    'validation-message': ValidationMessage
  }
}
</script>
